import React from 'react';

/**
 * Component to show the application is in a loading state.
 *
 * Basic loading message currently displayed.
 *
 * @returns {JSX.Element}
 * @component
 */
const Loading = () => {
  return (
    <div className="l-section__content-wrapper mt-12 pt-0 px-md-20">
      Loading
    </div>
  );
};

export default Loading;
